import { useEffect, useState } from "react";
import { history } from "configureStore";

// The conversation a push notification asked to open (nutivate-coaches#41). The service worker opens
// /app/chat?conversation=<id>, or, when the app is already open, focuses it and posts the id. The chat opens it
// once its conversations are loaded (ConversationExtras).
// Kept in sessionStorage too, so it survives the login a signed-out coach goes through first.
const STORAGE_KEY = "requestedConversation";
const listeners = new Set();

const stored = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

let requestedId = stored();

// Only a conversation id (digits) is kept; anything else from the URL or a push is ignored.
const setRequested = (id) => {
  requestedId = /^\d+$/.test(String(id || "")) ? String(id) : null;
  try {
    if (requestedId) sessionStorage.setItem(STORAGE_KEY, requestedId);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Only the sign-in case needs it.
  }
  listeners.forEach((listener) => listener(requestedId));
};

export const clearRequestedConversation = () => setRequested(null);

export const useRequestedConversation = () => {
  const [id, setId] = useState(requestedId);
  useEffect(() => {
    listeners.add(setId);
    setId(requestedId);
    return () => listeners.delete(setId);
  }, []);
  return id;
};

export const startOpenConversationListener = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("conversation")) {
    setRequested(params.get("conversation"));
    // A reload shouldn't open it again.
    params.delete("conversation");
    const search = params.toString();
    history.replace(`${window.location.pathname}${search ? `?${search}` : ""}`);
  }

  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (!event.data || event.data.type !== "nutivate:open-conversation") return;
    if (!window.location.pathname.startsWith("/app/chat")) history.push("/app/chat");
    setRequested(event.data.conversationId);
  });
};
